import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

import {
  NotificationActionsUnion,
  NotificationActionTypes
} from '@core/actions/notification.actions';

import { Notification } from '@app/models/notification';

export interface State extends EntityState<Notification> {
  loading: boolean;
  loaded: boolean;
  count: number;
}

export const adapter: EntityAdapter<Notification> = createEntityAdapter<
  Notification
>({
  selectId: (notification: Notification) => notification.id
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  creating: false,
  count: 0
});

export function reducer(
  state: State = INITIAL_STATE,
  action: NotificationActionsUnion
) {
  switch (action.type) {
    case NotificationActionTypes.Load:
      return { ...state, loading: true };

    case NotificationActionTypes.UpdateCounter:
      return { ...state, count: action.count };

    case NotificationActionTypes.LoadFail:
      return { ...state, loading: false };

    case NotificationActionTypes.LoadSuccess:
      return { ...state, loading: false, loaded: true };

    case NotificationActionTypes.AddAll:
      return adapter.addAll(action.notifications, state);

    case NotificationActionTypes.AddOne:
      return adapter.addOne(action.notification, state);

    case NotificationActionTypes.Update:
      return adapter.updateOne(
        { id: action.id, changes: action.notification.readAt },
        state
      );

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;
export const selectCounter = (state: State) => state.count;
